import { BasketWith } from '@aboutyou/backbone';
import { WishList } from 'modules/shop/wishlist/types';
import { client } from 'commerce/scayle/client';
import { Product } from 'commerce/scayle/utils/adapter';
import { errorWrapper } from 'commerce/utils/network';

const defaultConfig: { with: BasketWith } = {
  with: {
    items: {
      product: {
        attributes: 'all',
        advancedAttributes: 'all',
        variants: {
          attributes: 'all',
          advancedAttributes: 'all',
        },
      },
    },
  },
};

export const getWishlistById = (wishlistId: string) =>
  errorWrapper<WishList>(getWishlistById.name, async () => {
    const wishlist = await client.wishlist.get(wishlistId, defaultConfig);

    return {
      ...wishlist,
      items: wishlist.items.map((item) => ({
        ...item,
        adaptedProduct:
          item.product && Product.createProduct(item.product).toJSON(),
      })),
    };
  });

export const addItemToWishlist = (
  wishlistId: string,
  data: { variantId: number },
) =>
  errorWrapper<WishList>(addItemToWishlist.name, async () => {
    const { wishlist } = await client.wishlist.addItem(
      wishlistId,
      data,
      defaultConfig,
    );

    return {
      ...wishlist,
      items: wishlist.items.map((item) => ({
        ...item,
        adaptedProduct:
          item.product && Product.createProduct(item.product).toJSON(),
      })),
    };
  });

export const removeFromWishlist = (wishlistId: string, itemKey: string) =>
  errorWrapper<WishList>(removeFromWishlist.name, async () => {
    const wishlist = await client.wishlist.deleteItem(
      wishlistId,
      itemKey,
      defaultConfig,
    );

    return {
      ...wishlist,
      items: wishlist.items.map((item) => ({
        ...item,
        adaptedProduct:
          item.product && Product.createProduct(item.product).toJSON(),
      })),
    };
  });
